import { render, staticRenderFns } from "./TabDynamicRefund.vue?vue&type=template&id=316b8ac4&"
import script from "./TabDynamicRefund.vue?vue&type=script&lang=js&"
export * from "./TabDynamicRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports